module.exports = "/assets/e7320006679919359492e97dcb74323f.svg";